<!-- Скелетон загрузки (data === null) -->
<ng-container *ngIf="data === null">
  <div *ngIf="!isCardView" class="pa-table-skeleton">
    <div class="pa-table-skeleton-header">
      <div class="skeleton-item skeleton-header"></div>
      <div class="skeleton-item skeleton-header"></div>
      <div class="skeleton-item skeleton-header"></div>
      <div class="skeleton-item skeleton-header"></div>
    </div>
    <div class="pa-table-skeleton-rows">
      <div class="pa-table-skeleton-row" *ngFor="let item of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]">
        <div class="skeleton-item skeleton-cell"></div>
        <div class="skeleton-item skeleton-cell"></div>
        <div class="skeleton-item skeleton-cell"></div>
        <div class="skeleton-item skeleton-cell"></div>
      </div>
    </div>
  </div>

  <div *ngIf="isCardView" class="pa-table-cards-container">
    <div class="pa-table-card" *ngFor="let item of [1, 2, 3]">
      <div class="pa-table-card-header">
        <div class="skeleton-item skeleton-cell"></div>
      </div>
      <div class="info-list">
        <div class="info-item">
          <div class="skeleton-item skeleton-cell"></div>
          <div class="skeleton-item skeleton-cell"></div>
        </div>
        <div class="info-item">
          <div class="skeleton-item skeleton-cell"></div>
          <div class="skeleton-item skeleton-cell"></div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<!-- Основной контент (data.length > 0) -->
<div class="pa-table-container" [class.overflow-auto]="forceCardView" *ngIf="data !== null && data?.length > 0">
  <!-- Вид таблицы -->
  <div class="pa-table-view" *ngIf="!isCardView">
    <div class="pa-table-wrapper" (mouseleave)="hoveredRowIndex = null">
      <p-table
        [value]="data"
        [scrollHeight]="'flex'"
        [scrollable]="true"
        showGridlines
        [tableStyle]="{ 'min-width': '50rem' }"
        responsiveLayout="scroll"
      >
        <ng-template pTemplate="header">
          <tr>
            <th pFrozenColumn *ngIf="selectable" class="pa-table-checkbox-column" [style.width]="'60px'">
              <p-checkbox
                size="small"
                [binary]="true"
                [indeterminate]="isIndeterminate"
                [ngModel]="isAllSelected"
                (onChange)="onSelectAll($event)"
                ariaLabel="Выбрать все"
              >
              </p-checkbox>
            </th>
            <th *ngFor="let col of columns" class="cell" [style.minWidth]="col.width ?? 'auto'">
              <span class="cell-header">
                {{ col.header }}
                <i *ngIf="col.tooltip" class="pi pi-question-circle" [pTooltip]="col.tooltip" hideDelay="300"></i>
              </span>
            </th>
            <th [style.width]="'64px'" alignFrozen="right" pFrozenColumn *ngIf="hasActions()" class="pa-table-actions-column">
              {{ actionsLabel }}
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
          <!-- Группировка для десктопа -->
          <tr
            *ngIf="groupBy && isNewGroup(rowData, rowIndex)"
            paTableGroupRow
            [colspan]="groupColspan"
            [title]="getGroupTitle(rowData)"
            [subtitle]="getGroupSubtitle(rowData) || undefined"
            [expanded]="isGroupExpanded(getGroupKey(rowData))"
            (groupRowToggle)="handleGroupToggle(getGroupKey(rowData))"
          ></tr>

          <tr
            *ngIf="!groupBy || isGroupExpanded(getGroupKey(rowData))"
            [ngClass]="getClass(rowData, rowClassFn)"
            [class.pa-table-row-hovered]="hoveredRowIndex === rowIndex"
            (mouseenter)="hoveredRowIndex = rowIndex"
          >
            <td pFrozenColumn *ngIf="selectable" class="pa-table-checkbox-column">
              <p-checkbox
                size="small"
                [binary]="true"
                [ngModel]="isItemSelected(rowData)"
                (onChange)="onItemSelect(rowData, $event)"
                [ariaLabel]="'Выбрать строку'"
              >
              </p-checkbox>
            </td>
            <td
              *ngFor="let col of columns"
              class="cell"
              [class.with-hover-arrow]="col.showHoverArrow"
              (click)="onCellClick(rowData, $event)"
            >
              <div class="cell-content">
                <ng-container [ngSwitch]="col.type">
                  <ng-container *ngSwitchCase="PaTableColumnType.Date">
                    @if (isDateObject(rowData[col.field])) {
                      <div class="date-container">
                        <span [ngClass]="getDueDate(rowData, col.field) ? 'content' : 'content-empty'" class="date-text">
                          {{ (getDueDate(rowData, col.field) | date: tableDateFormat : undefined : tableDateLocale) ?? "—" }}
                        </span>
                        <span [pTooltip]="getRecurrentPeriodText(rowData[col.field]?.recurrent_period) || ''" tooltipPosition="top"
                          ><ion-icon name="repeat" slot="icon-only"></ion-icon
                        ></span>
                      </div>
                    } @else {
                      <span [ngClass]="getFieldValueAsDate(rowData, col.field) ? 'content' : 'content-empty'">
                        {{ (getFieldValueAsDate(rowData, col.field) | date: tableDateFormat : undefined : tableDateLocale) ?? "—" }}
                      </span>
                    }
                  </ng-container>
                  <span
                    [ngClass]="getFieldValueAsDate(rowData, col.field) ? 'content' : 'content-empty'"
                    *ngSwitchCase="PaTableColumnType.DateTime"
                  >
                    {{ (getFieldValueAsDate(rowData, col.field) | date: tableDateTimeFormat : undefined : tableDateLocale) ?? "—" }}
                  </span>
                  <span class="content" *ngSwitchCase="PaTableColumnType.Number">
                    {{ getFieldValueAsNumber(rowData, col.field) | number: "1.0-2" : "ru-RU" }}
                  </span>
                  <span class="content" *ngSwitchCase="PaTableColumnType.Boolean">
                    {{ getFieldValueAsBoolean(rowData, col.field) ? "Да" : "Нет" }}
                  </span>
                  <span class="content" *ngSwitchCase="PaTableColumnType.Currency">
                    {{ getFieldValueAsNumber(rowData, col.field) | currency: "RUB" : "symbol" : "1.0-2" : "ru-RU" }}
                  </span>
                  <ng-container *ngSwitchCase="PaTableColumnType.Select">
                    @if (rowData[col.field]?.name) {
                      <span class="content">
                        {{ rowData[col.field]?.name }}
                      </span>
                    } @else {
                      <span class="content-empty">—</span>
                    }
                  </ng-container>

                  <!-- Изображение с текстом -->
                  <ng-container *ngSwitchCase="PaTableColumnType.ImageText">
                    @if (getFieldValueAsImageText(rowData, col.field); as imageText) {
                      <div class="image-text-content">
                        @if (imageText.image) {
                          <img
                            [src]="imageText.image"
                            [alt]="imageText.name"
                            class="image-text-image"
                            onerror="this.style.display='none'"
                          />
                        }
                        <span class="content image-text-name">
                          {{ imageText.name || "—" }}
                        </span>
                      </div>
                    } @else {
                      <span class="content-empty">—</span>
                    }
                  </ng-container>

                  <!-- Иконка + текст -->
                  <ng-container *ngSwitchCase="PaTableColumnType.IconText">
                    @if (getFieldValueAsIconText(rowData, col.field); as iconText) {
                      <div class="icon-text-content" [attr.data-severity]="iconText?.severity || null">
                        @if (iconText?.icon || col.icon) {
                          <i class="icon-text-icon pi" [ngClass]="iconText?.icon || col.icon"></i>
                        }
                        <span class="content icon-text-text">
                          {{ iconText.text || "—" }}
                        </span>
                      </div>
                    } @else {
                      <span class="content-empty">—</span>
                    }
                  </ng-container>

                  <!-- Файлы -->
                  <ng-container *ngSwitchCase="PaTableColumnType.Files">
                    @if (getFieldValueAsFiles(rowData, col.field).length > 0) {
                      <pa-file-list [files]="getFieldValueAsFiles(rowData, col.field)"></pa-file-list>
                    } @else {
                      <span class="content-empty">—</span>
                    }
                  </ng-container>

                  <!-- Теги -->
                  <ng-container *ngSwitchCase="PaTableColumnType.Tags">
                    @if (getFieldValueAsTags(rowData, col.field).length > 0) {
                      <pa-tag-list [tags]="getFieldValueAsTags(rowData, col.field)"></pa-tag-list>
                    } @else {
                      <span class="content-empty">—</span>
                    }
                  </ng-container>

                  <!-- Изображения и файлы -->
                  <ng-container *ngSwitchCase="PaTableColumnType.Images">
                    <pa-table-files-cell [files]="getFieldValueAsFilesOrImages(rowData, col.field)"> </pa-table-files-cell>
                  </ng-container>

                  <!-- Диапазон времени (начало и конец) -->
                  <ng-container *ngSwitchCase="PaTableColumnType.TimeRange">
                    <div class="time-range-container">
                      <div class="time-range-wrapper">
                        <i
                          *ngIf="rowData[col.field].timeStart !== null && rowData[col.field].hours !== null"
                          class="pi pi-video time-icon"
                          [ngClass]="{ 'no-visible': !rowData[col.field].hasCameras }"
                        ></i>
                        <i
                          *ngIf="rowData[col.field].timeStart === null || rowData[col.field].hours === null"
                          class="pi pi-clock time-icon"
                          [ngClass]="{ 'time-icon-error': rowData[col.field].hours === null }"
                        ></i>
                        <span class="content time-range">
                          @if (rowData[col.field].timeStart !== null && rowData[col.field].timeEnd !== null) {
                            @if (rowData[col.field].hasCameras) {
                              <a
                                class="time-link"
                                title="Перейти к видеоархиву"
                                (click)="onTimeClick($event, rowData[col.field].pvzId, rowData[col.field].timeStart)"
                              >
                                {{ rowData[col.field].timeStart | date: "HH:mm" : "UTC" }}
                              </a>
                              <span class="time-separator"> — </span>
                              <a
                                class="time-link"
                                title="Перейти к видеоархиву"
                                (click)="onTimeClick($event, rowData[col.field].pvzId, rowData[col.field].timeEnd)"
                              >
                                {{ rowData[col.field].timeEnd | date: "HH:mm" : "UTC" }}
                              </a>
                            } @else {
                              <span class="time-text">{{ rowData[col.field].timeStart | date: "HH:mm" : "UTC" }}</span>
                              <span class="time-separator"> — </span>
                              <span class="time-text">{{ rowData[col.field].timeEnd | date: "HH:mm" : "UTC" }}</span>
                            }
                          } @else {
                            @if (rowData[col.field].timeStart !== null) {
                              @if (rowData[col.field].hasCameras) {
                                <a
                                  class="time-link"
                                  title="Перейти к видеоархиву"
                                  (click)="onTimeClick($event, rowData[col.field].pvzId, rowData[col.field].timeStart)"
                                >
                                  {{ rowData[col.field].timeStart | date: "HH:mm" : "UTC" }}
                                </a>
                              } @else {
                                <span class="time-text">{{ rowData[col.field].timeStart | date: "HH:mm" : "UTC" }}</span>
                              }
                            } @else {
                              <span class="time-text">--:--</span>
                            }
                            <span class="time-separator"> — </span>
                            @if (rowData[col.field].timeEnd !== null) {
                              @if (rowData[col.field].hasCameras) {
                                <a
                                  class="time-link"
                                  title="Перейти к видеоархиву"
                                  (click)="onTimeClick($event, rowData[col.field].pvzId, rowData[col.field].timeEnd)"
                                >
                                  {{ rowData[col.field].timeEnd | date: "HH:mm" : "UTC" }}
                                </a>
                              } @else {
                                <span class="time-text">--:--</span>
                              }
                            } @else {
                              <span class="time-text">--:--</span>
                            }
                          }
                        </span>
                      </div>
                      @if (rowData[col.field].hours !== null && rowData[col.field].hours > 0) {
                        <div class="time-total-wrapper">
                          <i class="pi pi-clock time-icon"></i>
                          <span class="time-total">
                            {{ (rowData[col.field].hours | number: "1.0-2").split(",")[0] }} ч.
                            @if ((rowData[col.field].hours | number: "1.2-2").split(",")[1] !== "00") {
                              {{ +("0." + (rowData[col.field].hours | number: "1.2-2").split(",")[1]) * 60 | number: "1.0-0" }}
                              мин.
                            }
                          </span>
                        </div>
                      }
                    </div>
                  </ng-container>

                  <!-- Массив -->
                  <ng-container *ngSwitchCase="PaTableColumnType.Array">
                    <pa-table-array-cell
                      [value]="rowData[col.field]"
                      [maxVisible]="col.arrayMaxVisible"
                      [modalTitle]="col.arrayModalTitle"
                    ></pa-table-array-cell>
                  </ng-container>

                  <!-- Telegram -->
                  <ng-container *ngSwitchCase="PaTableColumnType.Telegram">
                    <span class="content">
                      @if (rowData[col.field]) {
                        <a (click)="$event.stopPropagation()" [href]="'https://t.me/' + rowData[col.field]" target="_blank">{{
                          rowData[col.field]
                        }}</a>
                      } @else {
                        <span class="content-empty">—</span>
                      }
                    </span>
                  </ng-container>

                  <!-- Email -->
                  <ng-container *ngSwitchCase="PaTableColumnType.Email">
                    <span class="content">
                      @if (rowData[col.field]) {
                        <a (click)="$event.stopPropagation()" [href]="'mailto:' + rowData[col.field]">{{ rowData[col.field] }}</a>
                      } @else {
                        <span class="content-empty">—</span>
                      }
                    </span>
                  </ng-container>

                  <!-- Phone -->
                  <ng-container *ngSwitchCase="PaTableColumnType.Phone">
                    <span class="content">
                      @if (rowData[col.field]) {
                        <a (click)="$event.stopPropagation()" [href]="'tel:' + rowData[col.field]">{{ rowData[col.field] }}</a>
                      } @else {
                        <span class="content-empty">—</span>
                      }
                    </span>
                  </ng-container>

                  <!-- Ссылка -->
                  <ng-container *ngSwitchCase="PaTableColumnType.Link">
                    <span class="content">
                      @if (getFieldValueAsLink(rowData, col.field); as linkValue) {
                        @if (linkValue.label === '0') {
                          <span>{{ linkValue.label }}</span>
                        } @else {
                          <a
                            (click)="$event.stopPropagation();"
                            [href]="linkValue.href"
                          >
                            {{ linkValue.label }}
                          </a>
                        }
                      } @else {
                        <span class="content-empty">—</span>
                      }
                    </span>
                  </ng-container>

                  <!-- Текст -->
                  <ng-container *ngSwitchDefault>
                    @if (rowData[col.field]) {
                      <span class="content content-text">
                        {{ rowData[col.field] }}
                      </span>
                    } @else {
                      <span class="content-empty content-text">—</span>
                    }
                  </ng-container>
                </ng-container>
                <i *ngIf="col.showHoverArrow" class="pi hover-arrow" [ngClass]="getClass(rowData, hoverArrowClassFn)"></i>
              </div>
            </td>
            <td alignFrozen="right" pFrozenColumn *ngIf="hasActions()" class="pa-table-actions-column">
              <pa-context-menu [actions]="actions" [rowContext]="rowData"></pa-context-menu>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

  <!-- Вид карточек -->
  <div class="pa-table-cards" *ngIf="isCardView">
    <div class="pa-table-cards-container" *ngIf="cardItemTemplate; else defaultCardView">
      <ng-container *ngFor="let item of data; let i = index; trackBy: trackByItemId">
        <ng-container *ngTemplateOutlet="cardItemTemplate; context: getCardTemplateContext(item, i)"></ng-container>
      </ng-container>
    </div>
    <ng-template #defaultCardView>
      <div [ngClass]="groupBy ? 'pa-table-grouped-cards-container' : 'pa-table-cards-container'">
        <div *ngFor="let item of data; let i = index; trackBy: trackByItemId">
          <!-- Заголовок группы для мобильного вида -->
          <div class="pa-table-group-card-header" *ngIf="groupBy && isNewGroup(item, i)" (click)="handleGroupToggle(getGroupKey(item))">
            <div class="pa-table-group-card-header-text">
              <div class="pa-table-group-card-title">
                {{ getGroupTitle(item) }}
              </div>
              <div *ngIf="getGroupSubtitle(item)" class="pa-table-group-card-subtitle">
                {{ getGroupSubtitle(item) }}
              </div>
            </div>
            <i class="pi pa-table-group-row__icon" [ngClass]="isGroupExpanded(getGroupKey(item)) ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
          </div>

          <!-- Карточка строки -->
          <div class="pa-table-card" *ngIf="!groupBy || isGroupExpanded(getGroupKey(item))" (click)="onCellClick(item, $event)">
            <div class="pa-table-card-header" *ngIf="shouldShowCardHeader(item)">
              <div class="pa-table-card-header-left" (click)="$event.stopPropagation()">
                <p-checkbox
                  *ngIf="selectable"
                  [binary]="true"
                  [ngModel]="isItemSelected(item)"
                  (click)="$event.stopPropagation()"
                  (onChange)="onItemSelect(item, $event)"
                  [ariaLabel]="'Выбрать карточку'"
                  class="card-checkbox"
                >
                </p-checkbox>
                <span class="card-title" [ngClass]="getClass(item, rowClassFn)">
                  <span class="content">
                    {{ getCardTitle(item) }}
                  </span>
                </span>
              </div>

              <div class="pa-table-card-header-right" *ngIf="hasActions()">
                <pa-context-menu [actions]="actions" [rowContext]="item"></pa-context-menu>
              </div>
            </div>

            <div class="tags">
              <pa-tag-list [tags]="getFieldValueAsTags(item, 'tags')"></pa-tag-list>
            </div>

            <pa-data-list [data]="item | paTableRowToDataList: columns" size="regular"></pa-data-list>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</div>

<!-- Встроенная панель массовых действий -->
<div class="pa-table-bulk-bar-container" [ngClass]="{
    'pa-table-bulk-bar-container--no-pagination':
      !pagination || pagination.total_count <= pagination.per_page
}">
  <pa-bulk-actions-bar
    *ngIf="
      showBulkActionsBar &&
      hasBulkActions &&
      getSelectedCount() > 0
    "
    class="pa-table-bulk-bar"
    [ngClass]="{
      'pa-table-bulk-bar--with-pagination':
        pagination?.total_count > pagination?.per_page
    }"
    [selectedCount]="getSelectedCount()"
    [totalCount]="data?.length || 0"
    [showSelectAll]="true"
    [isAllSelected]="isAllSelected"
    [analyticsContext]="bulkActionsAnalyticsContext"
    [actions]="bulkActions"
    (close)="handleBulkCloseFromBar()"
    (toggleSelectAll)="handleBulkToggleSelectAllFromBar($event)"
    (actionClick)="handleBulkActionClickFromBar($event)"
  >
  </pa-bulk-actions-bar>
</div>

<!-- Пагинация для десктопа -->
<div class="pa-table-pagination" *ngIf="!isCardView && !groupBy && pagination && pagination.total_count > pagination.per_page">
  <p-paginator
    (onPageChange)="onPageChange($event)"
    [showFirstLastIcon]="true"
    [first]="pagination.page * pagination.per_page"
    [rows]="pagination.per_page"
    [totalRecords]="pagination.total_count"
  >
  </p-paginator>
</div>

<!-- Бесконечная прокрутка для мобильных -->
<ion-infinite-scroll
  *ngIf="data !== null && isCardView && this.pagination && data?.length > 0"
  (ionInfinite)="onInfiniteScroll($event)"
  threshold="100px"
>
  <ion-infinite-scroll-content loadingSpinner="bubbles" loadingText="Загрузка..."> </ion-infinite-scroll-content>
</ion-infinite-scroll>

<!-- Нет данных (data.length === 0) -->
<div class="pa-table-container empty-template" *ngIf="data !== null && data?.length === 0">
  <div class="pa-table-view">
    <div class="pa-table-wrapper">
      <ng-content select="[empty-template]"></ng-content>
    </div>
  </div>
</div>
